// extracted by mini-css-extract-plugin
export var statItem = "_hd-1";
export var statsRow = "_hd-0";